import styled from 'styled-components';
import { DealerCommentStyled } from '../DealerCommentStyled';
import { rem } from 'polished';

export const DealerCommentStyledAC = styled(DealerCommentStyled)`
    .titleWrapper {
        text-transform: unset;

        .title {
            font-size: ${rem(18)} !important;
            color: ${({ theme }) => theme.colors.grey5};
        }
    }
`;
